import React from 'react';

/** Typographic stand-in for the Ferring logo — replace with the official Ferring SVG asset. */
export function FerringWordmark({
  className = ''
}: {
  className?: string;
}) {
  return <span className={`inline-flex flex-col leading-none ${className}`} aria-label="Ferring Pharmaceuticals" data-id="element-74" data-mp="10b5tq0s02g3m">
      <span className="text-[17px] font-semibold tracking-[0.18em] text-ferring" data-id="element-75" data-mp="14czmznzv8htr">FERRING</span>
      <span className="mt-1 text-[7px] font-medium tracking-[0.42em] text-ferring/80" data-id="element-76" data-mp="7mqpm9aepi72">PHARMACEUTICALS</span>
    </span>;
}